export const prefixTranslationKey = (key: string, namespace: string) => {
  if (!namespace) return key
  const [first, ...rest] = key.split('.')
  return [first, namespace, ...rest].join('.')
}
